import Event from '../../core/Event';
import Customer from '../../../domain/Customer';

export default class UserDetailsGetSucceed extends Event {
    public static type = 'UserDetailsGetSucceed';

    constructor(public readonly customer: Customer) {
        super(UserDetailsGetSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/UserDetailsGetSucceed.ts